// Wait for deferred vendor scripts, including the Safari custom-element polyfill.
(() => {
  let bioInitialized = false;
  function initializeBioCollagen() {
    if (bioInitialized) return;
    bioInitialized = true;

;/* 28 Bio-Collagen ATF: scoped implementation */
(() => {
  if (customElements.get('bio-collagen-atf')) return;
  class BioCollagenATF extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.form = document.getElementById(this.dataset.formId);
      this.radios = [...this.querySelectorAll('[data-bio-variant]')];
      this.subscription = this.querySelector('[data-bio-subscription]');
      this.data = JSON.parse(this.querySelector('[data-bio-variants]')?.textContent || '{"variants":[]}');
      if (this.dataset.subscriptionRequired === 'true') this.data.requiresSellingPlan = true;
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency: this.dataset.currency || 'USD', minimumFractionDigits: 0, maximumFractionDigits: 2
      });
      this.radios.forEach(radio => { radio.disabled = !this.data.variants.find(v => String(v.id) === radio.value)?.available; });
      this.radios.forEach(radio => radio.addEventListener('change', () => this.updateSelection(), {signal}));
      this.subscription?.addEventListener('change', () => this.updateSelection(), {signal});
      if (!this.radios.some(radio => radio.checked && !radio.disabled)) {
        const available = this.radios.find(radio => !radio.disabled);
        if (available) available.checked = true;
      }
      if (this.form) {
        this.quantityInput = this.form.querySelector('[name="quantity"]');
        if (!this.quantityInput) {
          this.quantityInput = document.createElement('input');
          this.quantityInput.type = 'hidden';
          this.quantityInput.name = 'quantity';
          this.form.append(this.quantityInput);
        }
        this.form.addEventListener('submit', event => {
          if (this.submitting || this.form._bioRequestPending) {
            event.preventDefault(); event.stopImmediatePropagation(); return;
          }
          this.updateSelection();
          const error = this.validationError || this.giftError();
          if (error || !this.form.checkValidity()) {
            event.preventDefault(); event.stopImmediatePropagation();
            if (error) this.showError(error); else this.form.reportValidity();
            return;
          }
          this.submitting = true;
        }, {capture: true, signal});
        this.form.addEventListener('formdata', event => this.addGifts(event.formData), {signal});
        this.form.querySelector('[name="id"]')?.addEventListener('change', () => this.syncFromForm(), {signal});
        this.form.addEventListener('variant:changed', () => this.syncFromForm(), {signal});
        this.quantityInput.addEventListener('change', () => this.updateSelection(), {signal});
      }
      window.addEventListener('pageshow', event => {
        if (event.persisted) this.finishSubmission();
        this.updateSelection();
      }, {signal});
      window.addEventListener('popstate', () => {
        const id = new URL(location.href).searchParams.get('variant');
        const radio = this.radios.find(r => r.value === id && !r.disabled);
        if (radio) radio.checked = true;
        this.updateSelection();
      }, {signal});
      this.updateSelection();
      this.setupCountdown();
      this.updateOrderDate();
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) this.updateOrderDate();
      }, {signal});
      window.addEventListener('pageshow', () => this.updateOrderDate(), {signal});
      this.querySelectorAll('[data-bio-recommendation]').forEach(button => button.addEventListener('click', async () => {
        if (button.disabled) return;
        button.disabled = true;
        const status = button.closest('.bio-recommendation').querySelector('[role="status"]');
        status.textContent = '';
        try {
          const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
            method: 'POST', headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({items: [{id: Number(button.dataset.bioRecommendation), quantity: 1}]})
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || button.dataset.error);
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
        } catch (error) { status.textContent = error.message || button.dataset.error; }
        finally { button.disabled = false; }
      }, {signal}));
    }
    disconnectedCallback() {
      this.abort?.abort();
      clearTimeout(this.orderDateTimer);
      clearInterval(this.timer);
      this.timer = null;
      this.initialized = false;
      this.lastVariantId = null;
    }
    updateOrderDate() {
      clearTimeout(this.orderDateTimer);
      const dates = this.querySelectorAll('.bio-order-notice time');
      if (!dates.length) return;
      const now = new Date();
      const label = now.toLocaleDateString('en-US', {month: 'long', day: 'numeric'});
      const localDate = [now.getFullYear(), String(now.getMonth() + 1).padStart(2, '0'), String(now.getDate()).padStart(2, '0')].join('-');
      dates.forEach(date => {
        date.textContent = label;
        date.dateTime = localDate;
      });
      const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
      this.orderDateTimer = setTimeout(() => this.updateOrderDate(), midnight - now + 100);
    }
    planFor(radio, variant) {
      return variant?.plans.find(plan => String(plan.id) === radio?.dataset.bioPlanId);
    }
    formatPrice(cents) {
      if (typeof window.formatMoney !== 'function') return this.money.format(cents / 100);
      const formatted = document.createElement('span');
      formatted.innerHTML = window.formatMoney(cents);
      // Match the existing Liquid money_without_trailing_zeros presentation.
      return cents % 100 === 0 ? formatted.textContent.replace(/[.,]00(?=\D*$)/, '') : formatted.textContent;
    }
    syncFromForm() {
      if (this.syncing) return;
      const id = this.form.querySelector('[name="id"]')?.value;
      const radio = this.radios.find(r => r.value === id && !r.disabled);
      if (radio) {
        radio.checked = true;
        this.updateSelection();
      } else {
        this.canSubmit = false;
        this.validationError = this.dataset.bundleError;
        Array.from(this.form.elements).filter(button => button.type === 'submit').forEach(button => {
          button.disabled = true;
        });
      }
    }
    showError(message) {
      this.form?.dispatchEvent(new CustomEvent('cart-notification:show', {
        bubbles: true, cancelable: true, detail: {status: 'error', error: message}
      }));
    }
    finishSubmission() {
      this.submitting = false;
      if (!this.isConnected) return;
      this.updateSelection();
    }
    updateSelection() {
      this.radios.forEach(radio => {
        radio.disabled = !this.data.variants.find(v => String(v.id) === radio.value)?.available;
        radio.closest('.bio-bundle').classList.toggle('is-unavailable', radio.disabled);
      });
      if (this.radios.some(r => r.checked && r.disabled)) {
        const first = this.radios.find(r => !r.disabled);
        if (first) first.checked = true;
      }
      this.radios.forEach(radio => radio.closest('.bio-bundle').classList.toggle('is-selected', radio.checked));
      const buttons = Array.from(this.form?.elements || []).filter(button => button.type === 'submit');
      const selected = this.radios.find(radio => radio.checked);
      const variant = this.data.variants.find(item => String(item.id) === selected?.value);
      this.canSubmit = false;
      this.validationError = this.dataset.bundleError;
      if (!variant || !this.form) {
        buttons.forEach(button => { button.disabled = true; });
        return;
      }
      const plan = this.planFor(selected, variant);
      if (this.subscription) {
        this.subscription.disabled = this.data.requiresSellingPlan;
        if (this.data.requiresSellingPlan) this.subscription.checked = true;
      }
      const wantsSubscription = Boolean(this.subscription?.checked || this.data.requiresSellingPlan);
      this.querySelectorAll('[data-bio-renewal]').forEach(label => {
        label.textContent = plan ? `${this.formatPrice(plan.price)} refill · ${plan.name}` : '';
      });
      this.recurring = Boolean(plan && wantsSubscription);
      const master = this.form.querySelector('[name="id"]');
      master.value = variant.id;
      const changed = this.lastVariantId !== variant.id;
      if (changed) this.quantityInput.value = selected.dataset.bioQuantity || variant.quantityRule?.min || 1;
      let planInput = this.form.querySelector('[name="selling_plan"]');
      if (!planInput) {
        planInput = document.createElement('input'); planInput.type = 'hidden'; planInput.name = 'selling_plan';
        this.form.append(planInput);
      }
      planInput.disabled = !this.recurring;
      planInput.value = this.recurring ? plan.id : '';
      const description = this.querySelector('[data-bio-plan-description]');
      if (description) {
        description.hidden = description.dataset.show !== 'true' || (!this.recurring && Boolean(plan));
        description.textContent = this.recurring ? `${description.dataset.label} ${plan.name}` : description.dataset.unavailable;
      }
      this.radios.forEach(radio => {
        const item = this.data.variants.find(entry => String(entry.id) === radio.value);
        if (!item) return;
        const itemPlan = this.planFor(radio, item);
        const price = item.subscriptionDisplayPrice ?? itemPlan?.price ?? item.price;
        const card = radio.closest('.bio-bundle');
        card.querySelector('[data-bio-price]').textContent = this.formatPrice(price);
        const compare = card.querySelector('[data-bio-compare]');
        compare.textContent = this.formatPrice(item.compare);
        compare.hidden = item.compare <= price;
        card.querySelector('[data-bio-saving]').textContent = this.formatPrice(Math.max(0, item.compare - price));
        card.querySelector('.bio-saving').hidden = item.compare <= price;
      });
      this.querySelectorAll('[data-bio-gift]').forEach(gift => {
        const eligible = gift.getAttribute(`data-tier-${selected.dataset.bioTier}`) !== 'false' && (gift.dataset.subscriptionOnly !== 'true' || this.recurring);
        gift.hidden = !eligible;
        gift.dataset.giftEligible = String(eligible);
      });
      const quantity = Number(this.quantityInput.value);
      const rule = variant.quantityRule || {};
      const min = Number(rule.min) || 1, increment = Number(rule.increment) || 1;
      const quantityValid = Number.isSafeInteger(quantity) && quantity >= min && (!rule.max || quantity <= rule.max) && (quantity - min) % increment === 0;
      this.validationError = !variant.available ? this.dataset.bundleError
        : wantsSubscription && !plan ? this.dataset.planError
        : !quantityValid ? this.dataset.quantityError : '';
      this.canSubmit = !this.validationError;
      if (changed) {
        this.lastVariantId = variant.id;
        this.syncing = true;
        try {
          master.dispatchEvent(new Event('change', {bubbles: true}));
          this.form.dispatchEvent(new CustomEvent('variant:changed', {
            bubbles: true, detail: {variant: variant.shopify || variant}
          }));
        } finally { this.syncing = false; }
      }
      buttons.forEach(button => {
        button.disabled = !this.canSubmit || this.submitting || this.form._bioRequestPending;
        button.removeAttribute('title');
      });
      const stock = this.querySelector('[data-bio-stock]');
      if (stock) stock.textContent = variant.available ? stock.dataset.available : stock.dataset.unavailable;
    }
    eligibleGifts() {
      const seen = new Set();
      return [...this.querySelectorAll('[data-bio-gift][data-gift-id]')].filter(gift => {
        const id = gift.dataset.giftId;
        if (gift.hidden || !/^\d+$/.test(id) || seen.has(id)) return false;
        seen.add(id); return true;
      });
    }
    giftError() {
      const selected = this.querySelector('[data-bio-variant]:checked');
      if (Number(selected?.dataset.bioBogoQuantity) > 0 &&
          (!selected.dataset.bioBogoId || selected.dataset.bioBogoAvailable !== 'true')) {
        return 'The bonus packs are currently unavailable. Please choose another bundle.';
      }
      const mainId = this.form?.querySelector('[name="id"]')?.value;
      return this.eligibleGifts().some(gift => gift.dataset.giftId === mainId ||
        (Number(gift.dataset.giftPrice) !== 0 && gift.dataset.discountConfirmed !== 'true'))
        ? this.dataset.giftError : '';
    }
    addGifts(data) {
      const gifts = this.giftError() ? [] : this.eligibleGifts();
      const selected = this.querySelector('[data-bio-variant]:checked');
      const bonusId = Number(selected?.dataset.bioBogoId);
      const bonusQuantity = Number(selected?.dataset.bioBogoQuantity) || 0;
      const bundleQuantity = Number(data.get('quantity')) || 1;
      if ((!gifts.length && !bonusQuantity) || !data.has('id')) return;
      // Match the existing cart reconciler's ownership contract; never assign plans to gifts.
      for (const [key, value] of [...data.entries()]) {
        if (['id', 'quantity', 'selling_plan'].includes(key) || key.startsWith('properties[')) {
          const nestedKey = key.startsWith('properties[') ? `items[0][properties]${key.slice(10)}` : `items[0][${key}]`;
          data.append(nestedKey, value); data.delete(key);
        }
      }
      gifts.forEach((gift, index) => {
        data.set(`items[0][properties][_free gift ${index + 1}]`, gift.dataset.giftId);
        data.append(`items[${index + 1}][id]`, gift.dataset.giftId);
        data.append(`items[${index + 1}][quantity]`, '1');
        data.append(`items[${index + 1}][properties][_gift]`, 'true');
      });
      if (bonusQuantity && Number.isSafeInteger(bonusId) && bonusId > 0) {
        const index = gifts.length + 1;
        data.set('items[0][properties][_bio_bonus_variant]', String(bonusId));
        data.set('items[0][properties][_bio_bonus_quantity]', String(bonusQuantity));
        data.append(`items[${index}][id]`, String(bonusId));
        data.append(`items[${index}][quantity]`, String(bonusQuantity * bundleQuantity));
        data.append(`items[${index}][properties][_gift]`, 'true');
        data.append(`items[${index}][properties][_bio_bonus_pack]`, 'true');
        data.append(`items[${index}][properties][_bio_parent_variant]`, selected.value);
      }
    }
    setupCountdown() {
      clearInterval(this.timer);
      const timer = this.querySelector('[data-bio-countdown]');
      if (!timer) return;
      const duration = Math.max(1, Number(timer.dataset.duration) || 21600) * 1000;
      const fixed = timer.dataset.mode === 'deadline';
      const key = `bio-offer-${this.dataset.sectionId}-${timer.dataset.blockId}-${duration}-${timer.dataset.mode}-${timer.dataset.deadline}`;
      let deadline = fixed ? Date.parse(timer.dataset.deadline) : Date.now() + duration;
      if (!fixed) {
        try {
          const stored = Number(localStorage.getItem(key)) || Number(sessionStorage.getItem(key));
          if (stored > 0) deadline = stored;
          else if (timer.dataset.bioDeadline) deadline = Number(timer.dataset.bioDeadline);
          localStorage.setItem(key, String(deadline));
        } catch (_) {
          if (timer.dataset.bioDeadline) deadline = Number(timer.dataset.bioDeadline);
        }
        timer.dataset.bioDeadline = String(deadline);
      }
      const tick = () => {
        const now = Date.now();
        if (!fixed && (!Number.isFinite(deadline) || deadline <= now)) {
          deadline = now + duration;
          timer.dataset.bioDeadline = String(deadline);
          try { localStorage.setItem(key, String(deadline)); }
          catch (_) { try { sessionStorage.setItem(key, String(deadline)); } catch (_) {} }
        }
        const remaining = Number.isFinite(deadline) ? Math.max(0, Math.ceil((deadline - now) / 1000)) : 0;
        timer.textContent = [Math.floor(remaining / 3600), Math.floor(remaining % 3600 / 60), remaining % 60].map(value => String(value).padStart(2, '0')).join(':');
        if (!remaining) { clearInterval(this.timer); this.timer = null; }
      };
      this.timer = setInterval(tick, 1000); tick();
    }
  }
  customElements.define('bio-collagen-atf', BioCollagenATF);
})();


;/* 28 Bio-Collagen 1 isolated native product form */
(()=>{if(customElements.get('bio-product-form-1'))return;const BioProductForm1=class extends HTMLFormElement {
  connectedCallback() {
    this.id.disabled = false;
    if (this.closest('bio-collagen-atf')) {
      this._bioSubmitHandler ||= this._onSubmit.bind(this);
      this.removeEventListener('submit', this._bioSubmitHandler);
      this.addEventListener('submit', this._bioSubmitHandler);
    } else {
      this.addEventListener("submit", this._onSubmit.bind(this));
    }
  }
  async _onSubmit(event) {
    event.preventDefault();
    if (!this.checkValidity()) {
      this.reportValidity();
      return;
    }
    const bundlePicker = this.closest('bio-collagen-atf');
    if (bundlePicker && this._bioRequestPending) return;
    if (bundlePicker) this._bioRequestPending = true;
    let addedSuccessfully = false;
    const submitButtons = Array.from(this.elements).filter((button) => button.type === "submit");
    try {
    submitButtons.forEach((submitButton) => {
      submitButton.setAttribute("disabled", "disabled");
      submitButton.setAttribute("aria-busy", "true");
       const loader = submitButton.querySelector('.loader-button__loader');
        if (loader) {
          loader.removeAttribute('hidden');
        }
    });
    const productForm = new FormData(this);
    // if (mini_cart_template !== "" && mini_cart_template == 'Smooche_and_luxe') {
    //   productForm.append("sections", ["mini-cart-new"]);
    // } else {
    //   productForm.append("sections", ["mini-cart"]);
    // }
    if (template_name !== "" && template_name == 'Smooche') {
      productForm.append("sections", ["mini-cart-new"]);
    }  else if (template_name !== "" && template_name == 'Smooche-v2') {
      productForm.append("sections", ["mini-cart-new"]);
    }  else if (template_name !== "" && template_name == 'luxe') {
      productForm.append("sections", ["mini-cart-new"]);
    }else {
      productForm.append("sections", ["mini-cart"]);
    }
    productForm.delete("option1");
    productForm.delete("option2");
    productForm.delete("option3");
    const response = await fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
      body: productForm,
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest"
        // This is needed for the endpoint to properly return 422
      }
    });
    submitButtons.forEach((submitButton) => {
      submitButton.removeAttribute("disabled");
      submitButton.removeAttribute("aria-busy");
    });
    const responseJson = await response.json();
    if (response.ok) {
      addedSuccessfully = true;
      // if (window.location.href.includes('kojic-acid-turmeric-night')) {

      //   return window.location.href = '/checkout'; // Naveed added custom code to redirect to the checkout page for testing purposes.
      // } else {
      //   console.log('not working ' + window.location.href)
      // }
      if (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart") {
        return window.location.href = `${Shopify.routes.root}cart`;
      }

      this.dispatchEvent(new CustomEvent("variant:added", {
        bubbles: true,
        detail: {
          variant: responseJson.hasOwnProperty("items") ? responseJson["items"][0] : responseJson
        }
      }));
      const cartRefresh = fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async (response2) => {
        const cartContent = await response2.json();
        document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
          bubbles: true,
          detail: {
            cart: cartContent
          }
        }));
        cartContent["sections"] = responseJson["sections"];
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: {
            cart: cartContent,
            openMiniCart: window.themeVariables.settings.cartType === "drawer" && this.closest(".drawer") === null
          }
        }));

      // window.location.href="/checkout";
      });
      if (bundlePicker) await cartRefresh;
    }
    this.dispatchEvent(new CustomEvent("cart-notification:show", {
      bubbles: true,
      cancelable: true,
      detail: {
        status: response.ok ? "success" : "error",
        error: responseJson["description"] || ""
      }
    }));
    } catch (error) {
      if (!bundlePicker) throw error;
      this.dispatchEvent(new CustomEvent('cart-notification:show', {
        bubbles: true, cancelable: true,
        detail: {status: 'error', error: addedSuccessfully
          ? 'Your item was added. Please refresh the page to view your cart.'
          : 'Unable to add this item. Please try again.'}
      }));
    } finally {
      if (bundlePicker) {
        this._bioRequestPending = false;
        submitButtons.forEach(button => {
          button.removeAttribute('aria-busy');
          button.querySelector('.loader-button__loader')?.setAttribute('hidden', '');
        });
        bundlePicker.finishSubmission();
      }
    }
  }
};
customElements.define('bio-product-form-1',BioProductForm1,{extends:'form'});})();

  }
  if (document.readyState === 'complete') {
    initializeBioCollagen();
  } else {
    document.addEventListener('DOMContentLoaded', initializeBioCollagen, {once: true});
    // Also support a section script inserted after DOMContentLoaded but before load.
    window.addEventListener('load', initializeBioCollagen, {once: true});
  }
})();
